export default __webpack_public_path__ + "static/media/14341-biggamejames.5e53487b.pdf";